import { Link } from 'react-router-dom';

export default function Footer() {
  return (
    <footer className="bg-foreground-950 text-background-50">
      <div className="w-full px-6 md:px-10 py-14 md:py-20">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-10 md:gap-16">
          <div>
            <Link to="/" className="text-3xl md:text-4xl font-heading font-bold tracking-wide">
              yoybuy.cyou
            </Link>
            <p className="mt-6 text-sm text-foreground-300 leading-relaxed max-w-xs">
              Ваш надёжный инструмент для умного шоппинга из Китая. Таблицы заказов, сравнение агентов и удобная навигация по категориям товаров.
            </p>
            <div className="flex items-center gap-4 mt-6">
              <a href="#" className="w-10 h-10 rounded-full border border-foreground-500/40 flex items-center justify-center text-foreground-300 hover:text-white hover:border-white transition-colors cursor-pointer">
                <i className="ri-twitter-x-line"></i>
              </a>
              <a href="#" className="w-10 h-10 rounded-full border border-foreground-500/40 flex items-center justify-center text-foreground-300 hover:text-white hover:border-white transition-colors cursor-pointer">
                <i className="ri-telegram-line"></i>
              </a>
              <a href="#" className="w-10 h-10 rounded-full border border-foreground-500/40 flex items-center justify-center text-foreground-300 hover:text-white hover:border-white transition-colors cursor-pointer">
                <i className="ri-instagram-line"></i>
              </a>
              <a href="#" className="w-10 h-10 rounded-full border border-foreground-500/40 flex items-center justify-center text-foreground-300 hover:text-white hover:border-white transition-colors cursor-pointer">
                <i className="ri-youtube-line"></i>
              </a>
            </div>
          </div>

          <div className="space-y-8">
            <div>
              <p className="text-xs font-label font-semibold tracking-widest text-foreground-400 uppercase mb-2">Навигация</p>
              <div className="space-y-2">
                <Link to="/" className="block text-sm text-foreground-300 hover:text-white transition-colors">Главная</Link>
                <Link to="/yoybuy-sheet-guide" className="block text-sm text-foreground-300 hover:text-white transition-colors">Полное руководство</Link>
                <a href="#categories" className="block text-sm text-foreground-300 hover:text-white transition-colors">Категории товаров</a>
              </div>
            </div>
            <div>
              <p className="text-xs font-label font-semibold tracking-widest text-foreground-400 uppercase mb-2">Основной сайт</p>
              <div className="space-y-2">
                <a href="https://kaspreadsheet.com" target="_blank" rel="noopener nofollow" className="block text-sm text-foreground-300 hover:text-white transition-colors">kaspreadsheet.com</a>
                <a href="https://kaspreadsheet.com" target="_blank" rel="noopener nofollow" className="block text-sm text-foreground-300 hover:text-white transition-colors">Каталог товаров</a>
              </div>
            </div>
          </div>

          <div>
            <p className="text-xs font-label font-semibold tracking-widest text-foreground-400 uppercase mb-2">Популярные категории</p>
            <div className="space-y-2">
              <a href="https://kaspreadsheet.com/category-911-Shoes.html" target="_blank" rel="noopener nofollow" className="block text-sm text-foreground-300 hover:text-white transition-colors">Обувь</a>
              <a href="https://kaspreadsheet.com/search-912/name/Shoes.html" target="_blank" rel="noopener nofollow" className="block text-sm text-foreground-300 hover:text-white transition-colors">Худи / Свитеры</a>
              <a href="https://kaspreadsheet.com/search-913/name/Shoes.html" target="_blank" rel="noopener nofollow" className="block text-sm text-foreground-300 hover:text-white transition-colors">Футболки</a>
              <a href="https://kaspreadsheet.com/search-914/name/Shoes.html" target="_blank" rel="noopener nofollow" className="block text-sm text-foreground-300 hover:text-white transition-colors">Куртки</a>
              <a href="https://kaspreadsheet.com/search-920/name/Shoes.html" target="_blank" rel="noopener nofollow" className="block text-sm text-foreground-300 hover:text-white transition-colors">Аксессуары</a>
              <a href="https://kaspreadsheet.com/search-921/name/Shoes.html" target="_blank" rel="noopener nofollow" className="block text-sm text-foreground-300 hover:text-white transition-colors">Сумки</a>
            </div>
          </div>
        </div>
      </div>

      <div className="border-t border-foreground-800/50">
        <div className="w-full px-6 md:px-10 py-6 flex flex-col sm:flex-row items-center justify-between gap-4">
          <p className="text-xs text-foreground-500">
            &copy; {new Date().getFullYear()} yoybuy.cyou — Все права защищены.
          </p>
          <div className="flex items-center gap-6">
            <a href="#" className="text-xs text-foreground-500 hover:text-foreground-300 transition-colors">Политика конфиденциальности</a>
            <a href="#" className="text-xs text-foreground-500 hover:text-foreground-300 transition-colors">Условия использования</a>
            <a href="https://kaspreadsheet.com" target="_blank" rel="noopener nofollow" className="text-xs text-foreground-500 hover:text-foreground-300 transition-colors">kaspreadsheet.com</a>
          </div>
        </div>
      </div>
    </footer>
  );
}